<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='6'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Modification du code OAP</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="code"><strong>Code OAP : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="code" v-model="code" :class="{hasError: errors.code !== ''}" disabled></b-form-input>
                <span class='field-error'>{{ errors.code }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle"><strong>Libellé : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelleTechnique"><strong>Libellé technique : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelleTechnique" v-model="libelleTechnique" disabled></b-form-input>
            </b-col>
          </b-row>
          <!-- <b-row class="mb-1">
            <b-col sm="3">
              <label for="logo_path"><strong>Logo : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-file v-if="!logo_path" placeholder="Sélectionner le Logo"
                           class="file-input"
                           drop-placeholder="Déposer le fichier ici..."
                           browse-text="Parcourir"
                           :state="errors.attachment !== '' ? false : null"
                           @change="addFile($event)">
              </b-form-file>
              <span v-if="logo_path">
                <b-spinner v-if="loadingLogo" type="border" small></b-spinner>
                <img v-if="!loadingLogo" :src="logoBase64" class="clickable" @click="showLogo()" style="max-height: 100px;"> <i class="ml-3 clickable fa fa-trash text-danger" @click="deleteLogo()"></i>
              </span>
              <span class='field-error'>{{ errors.attachment }}</span>
            </b-col>
          </b-row> -->
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="structure"><strong>Structure : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-select id="structure" v-model="selectedStructure" :options="structuresOptions" :class="{hasError: errors.structure !== ''}"></b-form-select>
                <span class='field-error'>{{ errors.structure }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="email_from"><strong>Email From : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="email_from" v-model="email_from" :class="{hasError: errors.email_from !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.email_from }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="email_signature"><strong>Signature Email : </strong></label>
            </b-col>
            <b-col sm="9">
                <ckeditor :editor="editor" v-model="email_signature" :config="editorConfig"></ckeditor>
            </b-col> 
          </b-row>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Annuler
            </b-button>
            <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md='6'>
        <b-card style="height: 560px; overflow-y: hidden;">
          <h4>Liste des profils pour rattachement à l'OAP</h4>
          <VuePerfectScrollbar class="scroll-area-oap-oag" :settings="psSettings" @ps-scroll-y="scrollHandle">
            <b-form-checkbox
              class="mb-2 ml-1"
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            >Tous sélectionner
            </b-form-checkbox>
            <b-form-group
              v-slot="{ ariaDescribedby }" 
            >
              <b-form-checkbox v-for="profil in allProfil"
                class="ml-1"
                v-model="selectedProfils"
                :value="profil.id"
                :aria-describedby="ariaDescribedby"
                name="profils"
                :key="profil.id"
                stacked
              >{{ profil.libelle }}</b-form-checkbox>
            </b-form-group>
          </VuePerfectScrollbar>
        </b-card>
      </b-col>
    </b-row>

    <b-modal centered size="xl" id="modal-logo" ref="modal-logo" title="Logo">
      <img :src="logoBase64">
    </b-modal>
  </div>
</template>


<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty, permittedImageExtension} from "@/utils/fileHelper";
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: "Edit",
    components: {
      VuePerfectScrollbar
    },
    data() {
      return {
        code: '',
        libelle: '',
        libelleTechnique: '',
        // logo_path: '',
        // logoBase64: '',
        // attachment: '',
        selectedStructure: '',
        email_from: '',
        email_signature: '',
        allStructures: [],
        allProfil: [],
        selectedProfils: [],
        // loadingLogo: true,
        structuresOptions: [],
        allSelected: [],
        indeterminate: false,
        editor: ClassicEditor,
        editorConfig: {
          allowedContent: true,
          toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'],
          language: 'fr'
        },
        errors: {
          code: '',
          libelle: '',
          // logo_path: '',
          structure: '',
          // attachment: '',
          email_from: '',
          email_signature: '',
        },
      }
    },
    async mounted() {
      this.getProfiles();
      await this.getStructures();
      await this.getOap();
      // this.code = this.$route.params.code;
    },
    watch: {
      selectedProfils(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.allProfil.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
    },
    computed: {
      psSettings: () => {
        // ToDo: find better rtl fix
        return {
          maxScrollbarLength: 200,
          minScrollbarLength: 40,
          suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
          wheelPropagation: false,
          interceptRailY: styles => ({ ...styles, height: 0 })
        }
      }
    },
    methods: {
      scrollHandle (evt) {
        // console.log(evt)
      },
      async getOap() {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        await this.$axios
          .get("/administration/oap/" + this.$route.params.id)
          .then(response => {
            this.libelle = response.data.oap.libelle;
            this.libelleTechnique = response.data.oap.libelle_technique;
            this.code = response.data.oap.code;
            this.selectedStructure = response.data.oap.structure_id;
            // this.logo_path = response.data.oap.logo_path;
            this.email_from = response.data.oap.email_from
            this.email_signature = !isEmpty(response.data.oap.email_signature) ? response.data.oap.email_signature : '';
            this.$store.commit('IS_LOADING', false);
            // if (!isEmpty(response.data.oap.logo_path)) {
            //   this.getLogo();
            // } else {
            //   this.loadingLogo = false;
            // }
            for (let profil of response.data.oap.profils) {
              this.selectedProfils.push(profil.id);
            }
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            self.handleError(error);
          });
      },
      async getStructures() {
        await this.$axios
          .get("/administration/structures")
          .then(response => {
            this.allStructures = response.data.structures;
            for(let structures of response.data.structures){
              this.structuresOptions.push({value: structures.id, text: structures.libelle});
            }
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      getProfiles() {
        this.$axios
          .get("/administration/profiles")
          .then(response => {
            this.allProfil = response.data.profils;
            // for(let profile of response.data.profiles){
            //   this.structuresOptions.push({value: structures.id, text: structures.libelle});
            // }
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      toggleAll(checked) {
        this.selectedProfils = checked ? this.allProfil.map(item => {
          return item.id
        }) : []
      },
      addFile(event) {
        this.attachment = event.target.files[0]
      },
      edit() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let self = this;
          let code = this.code;
          let formData = new FormData();
          // formData.append('file', this.attachment);
          formData.append('code', this.code);
          formData.append('libelle', this.libelle);
          formData.append('libelleTechnique', this.libelleTechnique);
          formData.append('structure_id', this.selectedStructure);
          formData.append('email_from', this.email_from);
          formData.append('email_signature', this.email_signature);
          // formData.append('logo_path', this.logo_path);
          formData.append('profilIds', this.selectedProfils);

          this.$axios
            .post('/administration/oap/'+this.$route.params.id, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Modification avec succès',
                text: 'Le code OAP ' + code + ' a bien été modifié',
                showConfirmButton: false,
                timer: 5000
              });
              this.clearFields();
              this.returnBack();
            })
            .catch((error) => {
              self.$store.commit('IS_LOADING', false);
              self.handleError(error);
            });
        }
      },
      // getLogo() {
      //   let self = this;
      //   this.$axios
      //     .get("/referentielClient/oap/logo/"+this.$route.params.id)
      //     .then(response => {
      //       this.logoBase64 = response.data.logo;
      //       this.loadingLogo = false;
      //     })
      //     .catch((error) => {
      //       self.$store.commit('IS_LOADING', false);
      //       self.handleError(error);
      //     });
      // },
      // showLogo() {
      //   this.$refs['modal-logo'].show();
      // },
      // deleteLogo() {
      //   let self = this;
      //   this.$swal
      //     .fire({
      //       title: 'Êtes-vous sûr?',
      //       text: 'Voulez-vous vraiment supprimer ce logo ?',
      //       type: 'warning',
      //       reverseButtons: true,
      //       showCancelButton: true,
      //       cancelButtonColor: '#ff1744',
      //       confirmButtonText: 'Annuler',
      //       cancelButtonText: 'Supprimer'
      //     })
      //     .then(result => {
      //       if (!result.value) {
      //         this.$store.commit('IS_LOADING', true);
      //         this.$axios
      //           .delete('/administration/oap/delete/logo/' + this.$route.params.id)
      //           .then(() => {
      //             this.$store.commit('IS_LOADING', false);
      //             this.$swal({
      //               position: 'top',
      //               type: 'success',
      //               title: 'Suppression avec succès',
      //               text: 'Le logo a bien été supprimé',
      //               showConfirmButton: false,
      //               timer: 5000
      //             });
      //             this.getOap();
      //           })
      //           .catch((error) => {
      //             self.$store.commit('IS_LOADING', false);
      //             self.handleError(error);
      //           });
      //       }
      //     });
      // },
      returnBack() {
        this.$router.push({path: '/administration/gestionOapOag/oap/list'});
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.code.trim() === '') {
          this.errors.code = 'Le code est obligatoire';
          valid = false;
        }
        if (this.libelle.trim() === '') {
          this.errors.libelle = 'Le libellé est obligatoire';
          valid = false;
        }
        if (this.selectedStructure === '') {
          this.errors.structure = 'Le choix d\'une structure est obligatoire';
          valid = false;
        }
        // if (!isEmpty(this.attachment)) {
        //   if (!_.includes(permittedImageExtension, this.attachment.name.split('.').pop().toLowerCase())) {
        //     valid = false;
        //     this.errors.attachment = "Le Format de fichier n'est pas autorisé (formats autorisés : "+permittedImageExtension.join(', ')+")";
        //   }
        // }

        return valid;
      },
      clearErrors() {
        this.errors.code= '';
        this.errors.libelle = '';
        this.errors.structure = '';
        // this.errors.attachment = '';
      },
      clearFields() {
        this.code = '';
        this.libelle = '';
        this.libelleTechnique = '';
        // this.attachment = '';
      },
      handleError(error) {
        console.log(error)
        
        let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
        if (!isEmpty(error) && error.response && error.response.status === 403) {
          text = 'Vous n\'avez pas le droit de gérer cet OAP';
        } else if (!isEmpty(error) && error.response && (error.response.status === 406 || error.response.status === 424)) {
          text = error.response.data.message;
        } else if (error.response && error.response.status === 404 && this != undefined) {
          this.$router.push({path: '/administration/gestionOapOag/oap'})
          text: 'L\'OAP avec l\'id ' + this.$route.params.id + ' n\'existe pas';
        }
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: text,
          showConfirmButton: false,
          timer: 5000
        });
      },
    }
  }
</script>
<style type="text/css">
  .scroll-area-oap-oag {
    position: absolute;
    height: 88%;
    width: 90%;
  }
</style>
